module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "referouroffice"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome allfrmptags"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1), _c('h2', [_vm._v("Refer a Friend")]), _vm._m(0), _c('div', {
    staticClass: "main-form nextmainform"
  }, [_c('div', {
    staticClass: "innerapp"
  }, [_c('form', {
    attrs: {
      "action": "https://beaumontortho.com/email/",
      "method": "post"
    }
  }, [_vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfwfFwUAAAAAAUsIWtZ8aO3BS4O8lHPBoIwF7oi",
      "badge": "inline"
    }
  })], 1), _vm._m(7)])])]), _c('div', {
    staticClass: "clearboth"
  }), _c('h2', [_vm._v("Doctor Referral")]), _c('div', {
    staticClass: "left"
  }), _c('p', [_vm._v("If you are a doctor who is referring a patient to us, please fill out and submit the following form.")]), _c('div', {
    staticClass: "clearboth"
  })]), _c('div', {
    staticClass: "main-form"
  }, [_c('div', {
    staticClass: "innerapp"
  }, [_c('form', {
    attrs: {
      "action": "https://beaumontortho.com/email/",
      "method": "post"
    }
  }, [_vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _vm._m(14), _vm._m(15), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfwfFwUAAAAAAUsIWtZ8aO3BS4O8lHPBoIwF7oi",
      "badge": "inline"
    }
  })], 1), _vm._m(16)])])])])])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('p', [_vm._v("If you are a patient of record who has referred a new patient to us, please let us know by filling out and submitting the following form.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Name ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "flname",
      "id": "flname"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Email ")]), _c('input', {
    attrs: {
      "type": "email",
      "name": "emailID",
      "id": "emailID"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Friend's Name ")]), _c('input', {
    attrs: {
      "type": "friend",
      "name": "friendName",
      "id": "friendName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Your Friend's Phone Number ")]), _c('input', {
    attrs: {
      "type": "phone",
      "name": "phoneNo",
      "id": "phoneNo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Best Time to Call ")]), _c('input', {
    attrs: {
      "type": "timecall",
      "name": "timecall",
      "id": "timeCall"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Comments or Additional Info ")]), _c('textarea', {
    attrs: {
      "name": "message"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt buttonallrt"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "Refer Friend"
    }
  }), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit Referral",
      "onclick": "return validateFRForm()"
    }
  }), _c('p', {
    staticClass: "margin-10"
  }, [_vm._v("* Required")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Today's Date ")]), _c('input', {
    attrs: {
      "type": "date",
      "name": "todayDate",
      "id": "todayDate"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Name ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "yourName",
      "id": "yourName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Practice Name ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "praticeName",
      "id": "praticeName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your E-mail Address ")]), _c('input', {
    attrs: {
      "type": "email",
      "name": "emailID1",
      "id": "emailID1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Full name of the patient you are referring ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "referPName",
      "id": "referPName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes radioformbox"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Radiographs Sent? ")]), _c('div', {
    staticClass: "radies"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radioGraphs",
      "id": "radioGraphs",
      "value": "Yes",
      "checked": ""
    }
  }), _vm._v("Yes")]), _c('div', {
    staticClass: "radies"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radioGraphs",
      "id": "radioGraphs",
      "value": "No",
      "checked": ""
    }
  }), _vm._v("No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        If yes, when were they sent? ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "theySent",
      "id": "theySent"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Comments ")]), _c('textarea', {
    attrs: {
      "name": "message"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt buttonallrt"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "Doctor Referral"
    }
  }), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit Referral",
      "onclick": "return validateDRForm()"
    }
  }), _c('p', {
    staticClass: "margin-10"
  }, [_vm._v("* Required               ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1298724","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/refer-our-office/refer-our-office.pug
// module id = 611
// module chunks = 1